import { makeStyles } from '@material-ui/core/styles';
import { pxToRem } from '../../../../styles/themes/vad/constants';

const useStyles = makeStyles(theme => {
  const { marginLR, paddingLR } = theme.mixins;

  return {
    EventsDualCarouselSubLayout: {
      position: 'relative',

      '& .bg-wrapper': {
        position: 'absolute',
        width: '100%',
        left: 0,
        bottom: 0,
        zIndex: 0,

        '& img': {
          backgroundColor: 'transparent',

          [theme.breakpoints.down('md')]: {
            display: 'none',
          },
        },
      },

      '&.eventsDualCarouselVariant-1': {
        '& .bg-wrapper': {
          height: 'calc(100% - 14rem - 3rem - 7rem - 6rem)',

          [theme.breakpoints.down('md')]: {
            height: 'calc(100% - 14rem - 2rem - 5.5rem - 2.5rem)',
          },

          [theme.breakpoints.down('sm')]: {
            height: 'calc(100% - 14rem - 2rem - 5rem - 2.5rem)',
          },
        },
      },

      '&.eventsDualCarouselVariant-2': {
        '& .bg-wrapper': {
          height: 'calc(100% - 14rem - 3rem - 3rem - 6rem)',

          [theme.breakpoints.down('md')]: {
            height: 'calc(100% - 14rem - 1rem - 2.5rem - 2.5rem)',
          },

          [theme.breakpoints.down('sm')]: {
            height: 'calc(100% - 14rem - 1rem - 2rem - 2.5rem)',
          },
        },
      },
    }
  };
});

export default useStyles;
